/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface AttributeCardSignature {
  Element: HTMLDivElement;
  Args: {
    attribute: string;
    canSelect?: boolean;
    isSelected?: boolean;
    isDisabled?: boolean;
    isPlaceholder?: boolean;
    innerClassNames?: string;
    onSelect: (attribute: string) => unknown;
    onDeselect: (attribute: string) => unknown;
  };
}

export default class AttributeCard extends Component<AttributeCardSignature> {
  get canSelect() {
    return this.args.canSelect ?? true;
  }

  get isSelected() {
    return this.args.isSelected ?? false;
  }

  get isDisabled() {
    return this.args.isDisabled ?? false;
  }

  get isPlaceholder() {
    return this.args.isPlaceholder ?? false;
  }
}
